import { render, staticRenderFns } from "./CaseType.vue?vue&type=template&id=2e5dd15d"
import script from "./CaseType.vue?vue&type=script&lang=js"
export * from "./CaseType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports